<template>
    <div class="ai-image-website-content max-z-index" v-show="isShowHandleAi">
		<!-- Show loader while the iframe is loading -->
		<div class="iframe-loading" v-loading="isLoading" v-if="isLoading">
        <!-- <img src="/static/img/ajax-loader.gif" alt="Loading..." /> -->
	</div>
	<!-- Only render iframe when URL is available -->
	<iframe
        v-show="!!handleEnhanceWithAIUrl"
        width="100%"
        @load="onIframeLoad"
        :src="handleEnhanceWithAIUrl"
        frameborder="0"
        ref="aiImageIframe"
        id="aiImageIframe"
        class="ai-image-website-iframe"
	></iframe>
    </div>
</template>
<script>
import { WEBAPP_LAYOUT } from "../../../common/constants";
import { useStore } from 'vuex';
import { storeModules } from "../../../store";
import { LanguageHelper } from "../../../utils/language-helper";
import { AI_URI } from "../../../common/uri/property-uri.constants";
import { AI_IMAGE_EVENTS } from "../../../common/ai-image.constant";
import { postMessageForWebview } from "../../../utils/web-view";

export default {
    name: 'AIImageWebview',
    data() {
        return {
            aiImageIframe: null,
            handleEnhanceWithAIUrl: '',
            isShowHandleAi: false,
            isLoading: true,
        }
    },
    computed: {
        webappLayoutMode() {
            return this.$store.state[storeModules.Common].webappLayoutMode;
        },
        isWebview() {
            return this.webappLayoutMode === WEBAPP_LAYOUT.WEBVIEW;
        },
    },
    methods: {
        onIframeLoad() {
            this.isLoading = false;
        },
        async authenticateAndLoadAIImageApp() {
            try {
				if (!this.authState?.oauth2?.accessToken) {
					console.error("Authentication failed: Missing access token.");
					this.$message.error('Authentication failed: Missing access token.');
					this.isLoading = false;
					return;
				}

				const encodedAuthState = encodeURIComponent(JSON.stringify(this.authState));
				const encodedImageUrl = this.imageUrl ? encodeURIComponent(this.imageUrl) : '';

				this.handleEnhanceWithAIUrl = `${AI_URI.IMAGE_ENHANCEMENT}?authState=${encodedAuthState}&imageUrl=${encodedImageUrl}&language=${this.language}`;
			} catch (error) {
				console.error("Error authenticating and loading image enhancement app:", error);
				this.$message.error('Error authenticating and loading image enhancement app.');
				this.isLoading = false;
			}
		},
		async handleMessage(event) {
			console.log("HandleMessage", event);
			const { data } = event;
			const TYPE = data?.TYPE;
			const { type } = data

			const MessageType = TYPE || type

			switch (MessageType) {
				case AI_IMAGE_EVENTS.CANCEL: {
					postMessageForWebview("CANCEL")
					break;
				};
				case AI_IMAGE_EVENTS.SAVE: {
					const { name, image } = data
					postMessageForWebview("SAVE", { name, image })
					break;
				};
				case AI_IMAGE_EVENTS.REPLACE: {
					const { image } = data
					postMessageForWebview("REPLACE", { image })
					break;
				};
				default: {
					break;
				};
			}
		},
		async initData() {
			if (this.isWebview) {
				const vm = window;
				console.log("Webview config", vm);
				if (vm.chrome && vm.chrome.webview) {
					vm.chrome.webview.addEventListener("message", async (event) => {
						console.log("Listening signDocumentInfo");

                    if (event.data.message === "aiImageInfo") {
                        const { authState, language, imageUrl } =
                            event.data.data;
                        console.log("Receive data from message", event);
                        this.authState = authState;
                        this.language = language;
                        this.imageUrl = imageUrl;
                        await this.authenticateAndLoadAIImageApp();
						this.handleMessage = this.handleMessage.bind(this);
						window.addEventListener("message", this.handleMessage);
                    }
                });
            }
            console.log('Send message to webview');
            postMessageForWebview("COMPLETE_LOADING")
			}
		}
    },
	async created() {
		this.isShowHandleAi = true;
		this.initData();
	},
	beforeDestroy() {
		window.removeEventListener("message", this.handleMessage);
	}
}
</script>
<style scoped>
.ai-image-website-iframe {
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    left: 0;
    z-index: 9999;
}</style>